/*
 * Filename: onLoad-transfer-rule.controller.ts
 * Description: Controller for onload transfer rule
 */

import { CQAppConstant } from '../../../app-constants';
import { ICriteria } from '../../../components/template-configuration/layout-configuration-panel/ILayoutConfigurationPanel.Interface';
import { FormRuleController } from '../form-rule.controller';
import { ITransferRuleObject } from '../IRules.interface';

export class CQOnLoadTransferRuleController extends FormRuleController {
    public ruleJSON = {};

    constructor(ruleObject: any) {
        super();
        this.formRuleObject(ruleObject);
    }

    /**
     * @private
     * @memberof CQTransferRuleController
     */
    private formRuleObject = (ruleObject: { setValues: ITransferRuleObject[]; selectedfieldFullName: string; }) => {
        const transferRule = this.formRuleFilter(ruleObject);
        const componentRule = CQAppConstant.COMPONENT_EVENT_RULES_MAP;
        this.ruleJSON = {
            [componentRule.onLoadtransfer.key]: { onLoad:{ 'transfer': transferRule } }
        };
    }

    /**
     * @private
     * @memberof CQTransferRuleController
     */
    private formRuleFilter = (ruleObject: {setValues:ITransferRuleObject[], selectedfieldFullName:string}) => {
        const transferRuleData = ruleObject.setValues;
        const setValues: any[] = [];
        transferRuleData.forEach((setValueSection: any) => {
            const fields: string[] = [];
            const transferRuleObject = { fieldValue:'', fields, filter: '', action:{} };
            transferRuleObject.fieldValue = `record.${ruleObject.selectedfieldFullName}`
            setValueSection.addedCriterias.forEach((criteria: ICriteria) => {
                if(!criteria.field.includes('-') && !transferRuleObject.fields.includes(criteria.field)){
                    transferRuleObject.fields.push(criteria.field);
                }
                
                if (criteria.isDynamic
                    && criteria.operator !== CQAppConstant.EXISTS
                    && criteria.operator !== CQAppConstant.ISEMPTY) {
                    if(!criteria.compareTo.includes('-') && !transferRuleObject.fields.includes(criteria.compareTo)){
                        transferRuleObject.fields.push(criteria.compareTo);
                    }
                }
            });

            if(setValueSection.shouldSkip){
                transferRuleObject.filter = "true";
            }else{
                transferRuleObject.filter = this.formFilterString(setValueSection.complexLogicQuery, setValueSection.addedCriterias);
            }

            let actions: any = {};
            setValueSection.actionArray.forEach((rule: any) => {
                if (actions.hasOwnProperty(rule.selectedLookupValue)) {
                    actions[rule.selectedLookupValue].push(rule.selectedLayoutField);
                } else {
                    actions = { ...actions, [rule.selectedLookupValue]: [rule.selectedLayoutField] };
                }
            });
            transferRuleObject.action = actions;
            setValues.push(transferRuleObject);
        });
        return setValues;
    }
}

